import { render } from "./PersonShortCard.vue?vue&type=template&id=069b096c&scoped=true"
import script from "./PersonShortCard.vue?vue&type=script&lang=js"
export * from "./PersonShortCard.vue?vue&type=script&lang=js"

import "./PersonShortCard.vue?vue&type=style&index=0&id=069b096c&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-069b096c"]])

export default __exports__